/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import VClamp from 'vue-clamp'
Vue.component('VClamp', VClamp)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);



$(function() {
  /**
   * Next, we will create a fresh Vue application instance and attach it to
   * the page. Then, you may begin adding components to this application
   * or customize the JavaScript scaffolding to fit your unique needs.
   */

  if ($('input.datefilter').length > 0) {

    $('input.datefilter').daterangepicker({
        autoUpdateInput: false,
        "locale": {
          "format": "YYYY-MM-DD",
          "separator": " - ",
          "applyLabel": "Käytä",
          "cancelLabel": "Peruuta",
          "fromLabel": "Alkaen",
          "toLabel": "Asti",
          "customRangeLabel": "Kustomoitu",
          "weekLabel": "v",
          "daysOfWeek": [
              "Su",
              "Ma",
              "Ti",
              "Ke",
              "To",
              "Pe",
              "La"
          ],
          "monthNames": [
              "Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"
          ],
          "firstDay": 1
        },
    });

    $('input.datefilter').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD'));
    });

    $('input.datefilter').on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('');
    });

  }

});
